module.exports = __webpack_public_path__ + "img/sad.79712f47.png";